<template>
    <div class="o-subscriptions">
        <m-title
            title="Szanowny Kliencie"
            :subtitle="
                `Wybrałeś opcję ${tempSubscription.name} na ${tempSubscriptionPackage.time_amount} ${tempSubscriptionPackage.periods_amount_type.name}`
            "
        />
        <div class="l-row">
            <div class="l-row__column">
                <div class="m-card">
                    <div class="m-card__container o-subscriptions__summary">
                        <div class="m-card__column m-card__column--borderRight">
                            <p
                                class="a-text a-text--primary a-text--noMargin a-text--uppercase o-subscriptions__summaryColumn o-subscriptions__summaryColumn--centered"
                            >
                                Pakiet<br />
                                {{ tempSubscription.name }}
                            </p>
                        </div>
                        <div class="m-card__column m-card__column--padding20px">
                            <div class="o-subscriptions__summaryRow">
                                <p class="o-subscriptions__priceValue">
                                    {{ tempSubscriptionPackage.price }}
                                    <span class="a-text">{{
                                        tempSubscriptionPackage.currency.symbol
                                    }}</span>
                                </p>
                            </div>
                            <div class="o-subscriptions__summaryRow">
                                <div class="o-subscriptions__summaryColumn">
                                    <p
                                        class="a-text a-text--noMargin a-text--noBreak"
                                    >
                                        <span class="a-text--bold">{{
                                            pricePerMonth(
                                                tempSubscriptionPackage.price,
                                                tempSubscriptionPackage.time_amount
                                            )
                                        }}</span>
                                        {{
                                            tempSubscriptionPackage.currency
                                                .symbol
                                        }}&nbsp;/&nbsp;m-c
                                    </p>
                                </div>
                                <div class="o-subscriptions__summaryColumn">
                                    <p class="a-text a-text--noMargin">
                                        <span class="a-text--bold">
                                            {{
                                                tempSubscription.monthsValue
                                            }}</span
                                        >
                                        {{ tempSubscription.monthsText }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="l-row">
            <div class="l-row__column">
                <h2 class="a-text a-text--gray">Wprowadź dane do faktury</h2>
                <form @submit.prevent="submitPayment">
                    <m-control
                        label="NIP"
                        name="vatId"
                        ref="vatId"
                        placeholder="Wpisz NIP..."
                        v-model="invoice.vatId"
                    />
                    <m-control
                        label="Nazwa"
                        name="name"
                        ref="name"
                        placeholder="Firma lub imię i nazwisko..."
                        v-model="invoice.name"
                        required
                    />
                    <m-control
                        label="Adres"
                        name="address"
                        ref="address"
                        placeholder="Wpisz adres (ulica i nr)..."
                        v-model="invoice.address"
                        required
                    />
                    <m-control
                        label="Kod pocztowy"
                        name="postcode"
                        ref="postcode"
                        placeholder="Wpisz kod pocztowy..."
                        v-model="invoice.postcode"
                        required
                    />
                    <m-control
                        label="Miejscowość"
                        name="city"
                        ref="city"
                        placeholder="Wpisz miejscowość..."
                        v-model="invoice.city"
                        required
                    />
                    <a-button type="fullwidth" submit>
                        Przejdź do płatności online
                    </a-button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'subscriptionPayment',
    data() {
        return {
            invoice: {
                vatId: '',
                name: '',
                address: '',
                postcode: '',
                city: ''
            }
        }
    },
    computed: {
        tempSubscription() {
            return this.$store.getters['subscriptions/tempSubscription']
        },
        tempSubscriptionPackage() {
            return this.$store.getters['subscriptions/tempSubscriptionPackage']
        }
    },
    methods: {
        async submitPayment() {
            const { vatId, name, address, postcode, city } = this.invoice
            await this.$store.dispatch('clientDetails/saveClientDetails', {
                vat_id: vatId,
                company_name: name,
                postal_code: postcode,
                address: address,
                city: city
            })
            this.$store.dispatch(
                'subscriptions/submitPayment',
                this.tempSubscriptionPackage.id
            )
        },
        pricePerMonth(price, months) {
            const sum = price / months
            return sum.toFixed(2)
        }
    }
}
</script>
